import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { emailActions } from "@_actions/email_flows.actions";
import { templateActions } from "@_actions/template.actions";
import { getUserDataFromJwt } from "@_utils/helpers";
import RenameFlow from "@_components/RenameFlow/RenameFlow";
import styles from "./EmailFlowRow.module.css";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MenuItem from "@mui/material/MenuItem";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Menu from "@mui/material/Menu";
import EmailFlowTemplate from "@_components/EmailFlowTemplate/EmailFlowTemplate";
import { emailConstants } from "@_constants/email_flows.constants";
import WarningIcon from "@mui/icons-material/Warning";
import { Tooltip } from "@mui/material";
import { sidebarActions } from "@_actions/sidebar.actions";
import AreYouSurePopup from "@_components/popups/AreYouSurePopup/AreYouSurePopup";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

function EmailFlowRow(props) {
  const { data, handleSelectedFlow, selectedFlow } = props;
  let emailFlow = data;
  const ref = useRef(null);
  const anchorRef = React.useRef(null);
  const dispatch = useDispatch();
  const [openTemplateFlag, setOpenTemplateList] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [renameFlow, setRenameFlow] = useState(false);
  const [newFlowName, setNewFlowName] = useState({
    name: "",
  });
  const [inputChange, setInputChange] = useState(false);
  const [trigerredMails, setTrigerredMails] = useState([]);
  const [scheduledMails, setScheduledMails] = useState([]);
  const [customMails, setCustomMails] = useState([]);
  const [letters, setLetters] = useState([]);
  const [initialMailTemplate, setInitialMailTemplate] = useState(null);
  const [licenseValidatedTemplate, setLicenseValidatedTemplate] =
    useState(null);
  const [licenseRejectedTemplate, setLicenseRejectedTemplate] = useState(null);
  const [paymentRecievedTemplate, setPaymentRecievedTemplate] = useState(null);
  const [discountEndTemplate, setDiscountEndTemplate] = useState(null);
  const [flowConfig, setFlowConfig] = useState(null);
  const [openAreYouSurePopup, setOpenAreYouSurePopup] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  useEffect(() => {
    dispatch(templateActions.getTemplates(emailFlow.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const emailFlowReducer = useSelector((state) => state.emailFlowReducer);
  const templateReducer = useSelector((state) => state.templateReducer);
  const jwtData = getUserDataFromJwt();

  const handleOpenEditPopup = (event) => {
    event.stopPropagation();
    setOpenEditPopup((prev) => !prev);
  };

  const handleCloseEditPopup = () => {
    setOpenEditPopup(false);
  };

  // delete flow without templates and don't disply AreYouSurePopup
  const handleDeleteFlow = (event) => {
    event.stopPropagation();
    if (
      templateReducer.flow_templates &&
      templateReducer.flow_templates[emailFlow.id] &&
      templateReducer.flow_templates[emailFlow.id].length > 0
    ) {
      setOpenAreYouSurePopup(true);
    } else {
      // No templates, delete immediately
      performDelete();
    }
  };

  const performDelete = () => {
    dispatch(emailActions.deleteEmail(emailFlow.id));
    dispatch(sidebarActions.updateSelections(null));
    setOpenAreYouSurePopup(false);
  };

  const handleRenameFlow = (event) => {
    event.stopPropagation();
    setRenameFlow(true);
  };

  const handleInputChange = (e) => {
    setInputChange(true);
    const { name, value } = e.target;
    setNewFlowName((newFlowName) => ({
      ...newFlowName,
      [name]: value,
    }));
  };

  const handleSubmitInput = (e) => {
    e.preventDefault();
    if (newFlowName.name) {
      dispatch(
        emailActions.updateEmail(emailFlow.id, {
          name: newFlowName.name,
        }),
      );
    } else {
      setRenameFlow(false);
      setOpenEditPopup(false);
    }
  };

  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_PUT === "success") {
      setNewFlowName({ name: "" });
      setRenameFlow(false);
    }
  }, [dispatch, emailFlowReducer.status.EMAIL_FLOW_PUT]);

  useEffect(() => {
    if (templateReducer.success && templateReducer.templates === "") {
      dispatch(templateActions.getTemplates(emailFlow.id));
    }
  });

  useEffect(() => {
    if (!selectedFlow) setOpenTemplateList(false);
    else if (selectedFlow) setOpenTemplateList(true);
  }, [selectedFlow]);

  const handleToggleTemplateList = () => {
    if (!openTemplateFlag) {
      handleGetTemplates();
      handleSelectedFlow();
      history.push("/templates/email_flows/" + emailFlow.id);
    }
    dispatch(templateActions.selectTemplate({}));
    setOpenTemplateList(!openTemplateFlag);
  };

  const handleAddTemplate = (emailFlowID, templateType, trigger) => {
    dispatch(emailActions.selectEmail(emailFlowID));
    dispatch(
      templateActions.addTemplateState(
        true,
        templateType,
        trigger,
        emailFlowID,
      ),
    );
  };

  const handleSelectTemplate = (data) => {
    dispatch(emailActions.selectEmail(emailFlow.id));
    data["emailFlowId"] = emailFlow.id;
    dispatch(templateActions.selectTemplate(data));
    history.push(
      "/templates/email_flows/" + emailFlow.id + "/email_template/" + data.id
    );
  };

  const handleGetTemplates = () => {
    dispatch(emailActions.selectEmail(emailFlow.id));
  };

  useEffect(() => {
    if (templateReducer.flow_templates) {
      let key = Object.keys(templateReducer.flow_templates);
      key.forEach((key) => {
        let values = templateReducer.flow_templates[key];
        if (key === emailFlow.id) {
          setTemplateList(values);
        } else return;
      });
      const flowId = pathParts[2];
      if (pathParts.length === 5 && pathParts[3] === "email_template") {
        if (templateReducer.flow_templates[flowId]) {
          const templateId = pathParts[4];
          if (flowId === emailFlow.id) {
            const foundTemplate = templateReducer.flow_templates[flowId]?.find(
              (template) => template.id === templateId
            );
            if (foundTemplate) {
              dispatch(templateActions.selectTemplate(foundTemplate));
            } else {
              history.push("/page_not_found");
            }
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [dispatch, history, templateReducer.flow_templates, emailFlow.id]);

  useEffect(() => {
    if (emailFlowReducer.status.EMAIL_FLOW_GET === "success") {
      let tempFlowConfig = {};
      templateList.forEach((template) => {
        const templatePlaceholders = template.config?.placeholders;
        if (templatePlaceholders) {
          for (const placeholder of Object.values(templatePlaceholders)) {
            if (
              Object.keys(tempFlowConfig).length === 0 ||
              !tempFlowConfig[placeholder.type] ||
              new Date(tempFlowConfig[placeholder.type]?.updated) <
                new Date(placeholder.updated)
            ) {
              tempFlowConfig[placeholder.type] = placeholder;
            }
          }
        }
      });
      setFlowConfig(tempFlowConfig);
      emailActions.clearStatusMessage("EMAIL_FLOW_GET");
    }
  }, [
    dispatch,
    emailFlowReducer.status.EMAIL_FLOW_GET,
    templateList,
    emailFlow.id,
  ]);
  useEffect(() => {
    if (flowConfig && Object.keys(flowConfig).length > 0) {
      dispatch(emailActions.addFlowConfig(emailFlow.id, flowConfig));
    }
  }, [flowConfig, emailFlow.id, dispatch]);

  useEffect(() => {
    let updatedTrigerredMails = [];
    let updatedScheduledMails = [];
    let updatedCustomMails = [];
    let updatedLetters = [];
    setInitialMailTemplate(null);
    setLicenseValidatedTemplate(null);
    setLicenseRejectedTemplate(null);
    setPaymentRecievedTemplate(null);
    setDiscountEndTemplate(null);
    templateList.forEach((template) => {
      switch (template.type) {
        case emailConstants.TEMPLATE_TYPE_TRIGGERED:
          updatedTrigerredMails.push(template);

          switch (template.trigger_event) {
            case emailConstants.TRIGGER_EVENT_INITIAL:
              setInitialMailTemplate(template);
              break;
            case emailConstants.TRIGGER_EVENT_LICENSE_VALIDATED:
              setLicenseValidatedTemplate(template);
              break;
            case emailConstants.TRIGGER_EVENT_LICENSE_REJECTED:
              setLicenseRejectedTemplate(template);
              break;
            case emailConstants.TRIGGER_EVENT_PAID:
              setPaymentRecievedTemplate(template);
              break;
            case emailConstants.TRIGGER_EVENT_DISOUNT_END:
              setDiscountEndTemplate(template);
              break;
            default:
              break;
          }
          break;

        case emailConstants.TEMPLATE_TYPE_SCHEDULED:
          updatedScheduledMails.push(template);
          break;

        case emailConstants.TEMPLATE_TYPE_CUSTOM:
          updatedCustomMails.push(template);
          break;
        case emailConstants.TEMPLATE_TYPE_LETTER:
          updatedLetters.push(template);
          break;

        default:
          break;
      }
    });

    setTrigerredMails(updatedTrigerredMails);
    setScheduledMails(
      updatedScheduledMails.sort(
        (s1, s2) => s1.schedule_num_days - s2.schedule_num_days,
      ),
    );
    updatedCustomMails.sort((c1, c2) => c1.name.localeCompare(c2.name));
    updatedLetters.sort((l1, l2) => l1.name.localeCompare(l2.name));
    setLetters(updatedLetters);
    setCustomMails(updatedCustomMails);
  }, [templateList, dispatch, emailFlow.id]);

  useEffect(() => {
    setRenameFlow(renameFlow);
  }, [renameFlow]);

  return (
    <div>
      {renameFlow ? (
        <div
          className={styles.email_row_root}
          key={emailFlow.id}
          onClick={handleGetTemplates}
          ref={ref}
        >
          {props.message}
          <ListItem className={styles.flow_list_item}>
            <RenameFlow
              styles={styles}
              name={newFlowName.name}
              handleSubmitInput={handleSubmitInput}
              handleInputChange={handleInputChange}
              prevValue={emailFlow.name}
              id={emailFlow.id}
              onClickOutside={() => {
                setRenameFlow(false);
                setOpenEditPopup(false);
              }}
              customer_id={jwtData.customer_id}
              inputChange={inputChange}
            />
          </ListItem>
        </div>
      ) : (
        <>
          <div
            className={styles.email_row_root}
            key={emailFlow.id}
            onClick={(e) => {
              handleToggleTemplateList();
            }}
          >
            <ListItem className={styles.flow_list_item}>
              <AccountTreeIcon className={styles.account_tree_icon} />
              <b className={styles.input_container}>{emailFlow.name}</b>
              <div className={styles.edit_icon_container}>
                {!initialMailTemplate && scheduledMails.length > 0 && (
                  <Tooltip
                    title="initial email template missing"
                    placement="top"
                    arrow
                  >
                    <WarningIcon className={styles.warning_icon} />
                  </Tooltip>
                )}
                <MoreHorizIcon
                  className={styles.edit_icon}
                  onClick={handleOpenEditPopup}
                  ref={anchorRef}
                  aria-controls={openEditPopup ? "email-flow-menu" : undefined}
                  aria-haspopup="true"
                />
                <Menu
                  id="email-flow-menu"
                  anchorEl={anchorRef.current}
                  open={openEditPopup}
                  onClose={handleCloseEditPopup}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem onClick={handleRenameFlow}>Rename</MenuItem>
                  <MenuItem onClick={handleDeleteFlow}>Delete</MenuItem>
                </Menu>
              </div>
              {openTemplateFlag ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          </div>
          <AreYouSurePopup
            open={openAreYouSurePopup}
            close={() => setOpenAreYouSurePopup(false)}
            onClick={performDelete}
          >
            Your email flow contains templates that will be deleted, too. Do you
            want to proceed?
          </AreYouSurePopup>
        </>
      )}

      <Collapse in={openTemplateFlag} timeout="auto" unmountOnExit>
        <EmailFlowTemplate
          handleSelectTemplate={handleSelectTemplate}
          handleAddTemplate={handleAddTemplate}
          email={emailFlow}
          templateList={templateList}
          trigerredMails={trigerredMails}
          scheduledMails={scheduledMails}
          customMails={customMails}
          letters={letters}
          initialMailTemplate={initialMailTemplate}
          licenseValidatedTemplate={licenseValidatedTemplate}
          licenseRejectedTemplate={licenseRejectedTemplate}
          paymentRecievedTemplate={paymentRecievedTemplate}
          discountEndTemplate={discountEndTemplate}
          flowConfig={flowConfig}
        />
      </Collapse>
    </div>
  );
}

export default EmailFlowRow;
